<template>
    <div>
        <div class="edit" data-toggle="modal" :data-target="'#edit-'+this.id" ><span class="material-icons">edit</span></div>
        <div class="modal" tabindex="-1"  :id="'edit-'+this.id" ref="vuemodal" :key="'edit-'+this.id">
            <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content">
                    <div class="loader" v-if="loading">
                        <img src="/images/loading.svg" alt="Loading">
                    </div>
                    <div class="modal-header bg-primary text-white">
                        <h5 class="modal-title">Priekšmeta labošana</h5>
                        <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="modalMenu">
                            <span class="modalMenuItem" @click="changeStep('main')" :class="{'active': step === 'main'}">Pamatinformācija</span>
                            <span class="modalMenuItem" @click="changeStep('images')" :class="{'active': step === 'images'}">Attēli</span>
                        </div>
                        <div v-if="step=='main'">
                            <div class="row">
                                <div class="col-3">
                                    <div class="form-group">
                                        <label for="item_number">Numurs</label>
                                        <input type="text" id="item_number" name="item_number" v-model="item_number" class="form-control">
                                    </div>
                                </div>
                                <div class="col-3">
                                    <div class="form-group">
                                        <label for="item_name">Nosaukums</label>
                                        <input type="text" id="item_name" name="item_name" v-model="item_name" class="form-control">
                                    </div>
                                </div>
                                <div class="col-3">
                                    <div class="form-group">
                                        <label for="item_name">Veids</label>
                                        <select name="item_type" id="item_type" class="form-control" v-model="item_type">
                                            <option value="main">Pamatkrājums</option>
                                            <option value="pk">Palīgkrājums</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-3">
                                    <div class="form-group">
                                        <label for="item_author">Autors</label>
                                        <input type="text" id="item_author" name="item_author" v-model="item_author" class="form-control">
                                    </div>
                                </div>
                                <div class="col-3">
                                    <div class="form-group">
                                        <label for="item_material">Materiāls</label>
                                        <input type="text" id="item_material" name="item_material" v-model="item_material" class="form-control">
                                    </div>
                                </div>
                                <div class="col-3">
                                    <div class="form-group">
                                        <label for="item_size">Izmērs</label>
                                        <input type="text" id="item_size" name="item_size" v-model="item_size" class="form-control">
                                    </div>
                                </div>
                                <div class="col-1">
                                    <div class="form-group">
                                        <label for="item_count">Skaits</label>
                                        <input type="text" id="item_count" name="item_count" v-model="item_count" class="form-control">
                                    </div>
                                </div>
                                <div class="col-2">
                                    <div class="form-group">
                                        <label for="item_value">Vērtība</label>
                                        <input type="text" id="item_value" name="item_value" v-model="item_value" class="form-control">
                                    </div>
                                </div>
                                <div class="col-3">
                                    <div class="form-group">
                                        <label for="condition">Stāvoklis</label>
                                        <input type="text" id="condition" name="condition" v-model="condition" class="form-control">
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="notes">Piezīmes</label>
                                        <textarea name="notes" id="notes"
                                                  rows="5" v-model="notes" class="form-control">{{notes}}</textarea>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="item_description">Apraksts</label>
                                        <textarea name="item_description" id="item_description"
                                                  rows="5" v-model="item_description" class="form-control">{{item_description}}</textarea>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="step=='images'">
                            <CoolLightBox
                                :items="imageListForLightbox"
                                :index="index"
                                srcName="src"
                                @close="index = null">
                            </CoolLightBox>

                            <div class="form-group">
                                <dropzone ref="images"  @vdropzone-success="dropzoneImageSuccess" @vdropzone-error="dropzoneImageError" :useCustomSlot=true :options="{headers:headers,parallelUploads: 1, previewTemplate: template(),url: '/temp-item/'+this.id+'/image-upload',maxFilesize: 10, acceptedFiles: ' .jpeg,.jpg,.png,.gif ', thumbnailWidth: 20}" id="file">
                                    <div class="dropzone-custom-content">
                                        <h3 class="dropzone-custom-title">Pievienot attēlus</h3>
                                    </div>
                                </dropzone>
                            </div>
                            <div class="gallery">
                                <div v-for="(image, imageIndex) in this.images" :key="image.id" class="galleryItem">
                                    <div class="image">
                                        <img @click="index = imageIndex" :src="'/temp-item/'+image.temp_item_id+'/image/'+image.file">
                                        <div class="delete" @click="deleteImage(image.id)">
                                            <span class="material-icons">close</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="modal-footer text-right">
                        <button class="btn btn-primary" v-if="loading ==false" @click="save()" key="save">Saglabāt</button>
                        <button class="btn btn-primary" v-if="loading ==true" key="loading"><i class="fas fa-spinner fa-spin"></i></button>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.gallery{
    display:flex;
    flex-wrap:wrap;
    .galleryItem{
        padding:10px;
        position: relative;
        width:25%;
        .delete{
            position:absolute;
            top:20px;
            right:20px;
            width:30px;
            height:30px;
            background:rgba(255,255,255,.75);
            cursor: pointer;
            border-radius: 100%;
            display:flex;
            align-items: center;
            justify-content: center;

        }
    }
    img{
        max-width:100%;
        height:auto;
    }
}
</style>

<script>
import Draggable from "vuedraggable";
import Dropzone from "vue2-dropzone";

export default{
    components: {
        'draggable':Draggable,
        Dropzone
    },
    props:['item'],
    mounted()
    {
        this.id = this.$props.item.id;
        this.item_name = this.$props.item.item_name;
        this.item_author = this.$props.item.item_author;
        this.item_description = this.$props.item.item_description;
        this.item_material = this.$props.item.item_material;
        this.item_size = this.$props.item.item_size;
        this.item_count = this.$props.item.item_count;
        this.item_number = this.$props.item.item_number;
        this.item_value = this.$props.item.item_value;
        this.condition = this.$props.item.condition;
        this.notes = this.$props.item.notes;
        this.item_type = this.$props.item.item_type;

        this.images = this.$props.item.images;
    },
    data()
    {
      return {
          id:"",
          item_name:"",
          item_author:"",
          item_description:"",
          item_material:"",
          item_size:"",
          item_count:"",
          item_number:"",
          item_value:"",
          condition:"",
          notes:"",
          item_type:"",

          images:[],
          drag: false,
          index:null,

          step:'main',
          loading:false,

          headers: {
              "X-CSRF-TOKEN": document.head.querySelector("[name=csrf-token]").content
          },
          template: function () {
              return `<div class="dz-preview dz-file-preview">
                    <div class="dz-details">
                        <div class="dz-filename"><span data-dz-name></span></div>
                        <div class="dz-size"><span data-dz-size></span></div>

                    </div>
                    <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>
                    <div class="dz-error-message"><span data-dz-errormessage></span></div>

                </div>
            `;
          },
      }
    },
    methods:{
        deleteImage(image_id)
        {
            var that = this;
            that.$swal.fire({
                title: 'Vai tiešām vēlaties dzēst attēlu?',
                icon: 'error',
                showCancelButton: true,
                confirmButtonColor: '#E53935',
                cancelButtonColor: '#888787',
                confirmButtonText: 'Dzēst',
                cancelButtonText: 'Atcelt'
            }).then((result) => {
                if (result.value) {
                    axios.post('/temp-item/' + this.id + '/image-delete/' + image_id)
                        .then(response => {
                        if (response.data.status == 'ok') {
                            that.images = response.data.images;
                            this.$toast.open(response.data.message);
                        }
                        if (response.data.status == 'error') {
                            this.$toast.error(response.data.message);
                        }
                    });
                }
            });
        },
        dropzoneImageSuccess(file, response)
        {

            var that = this;
            that.images = response.images;
            this.$toast.open("Attēls - "+response.image.file+" - veiksmīgi augšupielādēts.");
            if(Array.isArray(this.$refs.images))
            {
                this.$refs.images.forEach(dz => {
                    dz.removeFile(file)
                });
            }
            else
            {
                this.$refs.images.removeFile(file);
            }
            this.errors = [];

        },
        dropzoneImageError(file, message, xhr)
        {

            this.$toast.open({
                message: "Attēla augšupielāde neizdevās."+message,
                position: "top-right",
                type:"error",
            });
            if(Array.isArray(this.$refs.images))
            {
                this.$refs.images.forEach(dz => {
                    dz.removeFile(file)
                });
            }
            else
            {
                this.$refs.images.removeFile(file);
            }
        },
        changeStep(step)
        {
            this.step = step;
        },
      save()
      {
          var that = this;
          axios.post('/temp-item/update/'+that.id,{
              item_name:this.item_name,
              item_author:this.item_author,
              item_description:this.item_description,
              item_material:this.item_material,
              item_size:this.item_size,
              item_count:this.item_count,
              item_number:this.item_number,
              item_value:this.item_value,
              condition:this.condition,
              notes:this.notes,
              item_type:this.item_type,
            }).then(response =>{
             if(response.data.status == 'ok')
             {
                 EventBus.$emit('items_updated', response.data.act.items);
                 that.$toast.open(response.data.message);
                 $(this.$refs.vuemodal).modal('toggle');
             }
              if(response.data.status == 'error')
              {
                  that.$toast.error(response.data.message);
              }
          });
      }

    },

    computed: {
        imageListForLightbox()
        {
            if(this.images)
            {
                return this.images.map(function(image)
                {
                    return {
                        src:'/temp-item/'+image.temp_item_id+'/image/'+image.file,
                        //src:'/storage/items/'+image.item_id+'/images/generated/original/'+image.file_name,
                        description:image.filename
                    }
                });
            }
            else
            {
                return [];
            }

        },
        dragOptions() {
            return {
                animation: 200,
                // group: "description",
                disabled: false,
                ghostClass: "ghost"
            };
        },
    },
}
</script>
